import { apiClient } from '../client';

/**
 * Endpoints relacionados a mensagens individuais
 */

/**
 * Envia uma mensagem individual
 * @param {Object} messageData - Dados da mensagem
 * @param {string} messageData.recipient_type - Tipo de destinatário: 'STUDENT', 'RESPONSABLE' ou 'CLASSROOM'
 * @param {string} [messageData.recipient_idSponte] - ID Sponte do destinatário (obrigatório se não for CLASSROOM)
 * @param {number} [messageData.classroom_id] - ID da turma (obrigatório se recipient_type for CLASSROOM)
 * @param {string} messageData.title - Título da mensagem
 * @param {string} messageData.message - Conteúdo da mensagem
 * @param {string} messageData.unit - Unidade: 'CAMPINA GRANDE' ou 'PATOS'
 * @returns {Promise<Object>} Resultado do envio
 */
export const sendIndividualMessage = async (messageData) => {
  const { data } = await apiClient.post('/individual-messages/send', messageData);
  return data;
};

/**
 * Lista mensagens de um destinatário
 * @param {string} idSponte - ID Sponte do destinatário
 * @returns {Promise<Array>} Lista de mensagens
 */
export const getIndividualMessages = async (idSponte) => {
  const { data } = await apiClient.get(`/individual-messages/list/${idSponte}`);
  return data || [];
};

/**
 * Busca uma mensagem por ID
 * @param {number} id - ID da mensagem
 * @param {string} idSponte - ID Sponte do destinatário (para validação)
 * @returns {Promise<Object>} Mensagem encontrada
 */
export const getIndividualMessageById = async (id, idSponte) => {
  const { data } = await apiClient.get(`/individual-messages/${id}`, {
    params: { idSponte },
  });
  return data;
};

/**
 * Marca uma mensagem como lida
 * @param {number} id - ID da mensagem
 * @param {string} idSponte - ID Sponte do destinatário
 * @returns {Promise<Object>} Resultado da operação
 */
export const markIndividualMessageAsRead = async (id, idSponte) => {
  const { data } = await apiClient.put(`/individual-messages/${id}/read`, {
    idSponte,
  });
  return data;
};

/**
 * Conta mensagens não lidas de um destinatário
 * @param {string} idSponte - ID Sponte do destinatário
 * @returns {Promise<number>} Quantidade de mensagens não lidas
 */
export const getUnreadIndividualMessagesCount = async (idSponte) => {
  const { data } = await apiClient.get(`/individual-messages/unread/${idSponte}`);
  return data.count || 0;
};

/**
 * Consulta histórico de notificações de um aluno (aluno + responsáveis)
 * @param {string} idSponte - ID Sponte do aluno
 * @param {string} unit - Unidade: CAMPINA GRANDE ou PATOS
 * @returns {Promise<Object>} Histórico consolidado
 */
export const getStudentNotificationHistory = async (
  idSponte,
  unit,
  scope = "ALL",
  responsableIdSponte = null
) => {
  const { data } = await apiClient.get(`/individual-messages/history/student/${idSponte}`, {
    params: {
      unit,
      scope,
      ...(responsableIdSponte ? { responsableIdSponte } : {}),
    },
  });
  return data;
};


